import { ManualEditState } from "@/api/images-types";
import {
  getTextValue,
  handleMultiSelectChange,
  handleSingleSelectChange,
  handleTextChange,
  parseFiltersByField,
} from "@/components/ui/filters/filterHandlers";
import { MultiSelectFilter } from "@/components/ui/filters/MultiSelectFilter";
import { SingleSelectFilter } from "@/components/ui/filters/SingleSelectFilter";
import { TextFilter } from "@/components/ui/filters/TextFilter";
import { ManualEditStateChip } from "@/components/ui/state-chips/ManualEditStateChip";
import {
  manualEditStateOptions,
  rejectionReasonsOptions,
} from "@/utils/datagrid-utils";
import { DeleteOutline } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { GridFilterItem } from "@mui/x-data-grid";
import { useMemo } from "react";

type ManualEditFiltersProps = {
  items: GridFilterItem[];
  onChange: (items: GridFilterItem[]) => void;
};

export function ManualEditFilters({ items, onChange }: ManualEditFiltersProps) {
  const filtersByField = useMemo(() => parseFiltersByField(items), [items]);

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
      <TextFilter
        field="id"
        label="Image ID"
        value={getTextValue("id", filtersByField)}
        onChange={(field, val) => handleTextChange(field, val, items, onChange)}
      />
      <SingleSelectFilter
        field="isChildPresented"
        label="Child Present"
        options={[
          { value: "true", label: "Yes" },
          { value: "false", label: "No" },
        ]}
        value={getTextValue("isChildPresented", filtersByField)}
        onChange={(field, val) =>
          handleSingleSelectChange(field, val, items, onChange)
        }
      />
      <MultiSelectFilter
        field="manualEditState"
        label="State"
        options={manualEditStateOptions}
        value={filtersByField["manualEditState"] ?? []}
        onChange={(field, val) =>
          handleMultiSelectChange(field, val, items, onChange)
        }
        renderChip={(stateValue, onDelete) => (
          <ManualEditStateChip
            state={stateValue as ManualEditState}
            onDelete={onDelete}
          />
        )}
      />
      <MultiSelectFilter
        field="rejectionReasons"
        label="Rejection Reason"
        options={rejectionReasonsOptions}
        value={filtersByField["rejectionReasons"] ?? []}
        onChange={(field, val) =>
          handleMultiSelectChange(field, val, items, onChange)
        }
        freeSolo
      />
      <IconButton disabled={items.length === 0} onClick={() => onChange([])}>
        <DeleteOutline />
      </IconButton>
    </Stack>
  );
}
